import * as React from "react";

import { cn } from "../../lib/utils";

const Input = React.forwardRef((props, ref) => {
  return (
    <input
      {...props}
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-300",
        props.className // Safely apply the `className` prop here
      )}
    />
  );
});
Input.displayName = "Input";

export { Input };
